module.exports = __webpack_public_path__ + "img/watermanchallenge.0b20b26a.png";